import * as Bridge from '@/api/BridgeApi'
import { App } from '@/components/App'
import { initDev } from '@/dev'
import { LANGUAGE, LANGUAGE_FOR_I18N } from '@/domains/CommonDomain'
import { rootReducer, rootSaga, rootSagaBeta } from '@/modules'
import bridgeCore from '@/utils/bridgeUtils'
import * as numeral from '@/utils/currencyUtils'
import { isDevelopmentMode } from '@/utils/environmentUtils'
import history from '@/utils/historyUtils'
import * as i18n from '@/utils/i18nUtils'
import { isUndefined } from '@/utils/validationUtils'
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { oc } from 'ts-optchain'
import * as api from './api'
import { appAsync } from './modules/common/app'
import './polyfills'
import { EmptyNativeInfo, INativeInfo } from './utils/bridgeUtils/features/getNativeInfo'

const sagaMiddleware = createSagaMiddleware()
const middlewares = [sagaMiddleware]
const { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ } = window as any
const composeEnhancers = isDevelopmentMode
  ? isUndefined(__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
    ? compose
    : __REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  : compose

export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(...middlewares)))
export type StoreType = typeof store
const initNativeInfo = (store: StoreType, nativeInfo: INativeInfo) =>
  store.dispatch({ type: appAsync.SUCCESS, payload: { result: nativeInfo } })

export const version_name = 'version' // version
export const deeplink_name = 'deeplink' // deeplink
export const cmode_name = 'cmode' // cmode : biller 구분값(api 호출시 이용: /main 에서만)

export function getParam(sname: string) {
  let params: any = window.location.search.substr(window.location.search.indexOf('?') + 1)
  var sval = null
  params = params.split('&')

  for (var i = 0; i < params.length; i++) {
    let temp: any = params[i].split('=')
    if (temp[0] === sname) {
      sval = temp[1]
    }
  }

  return sval
}

interface versionRow {
  id: string
  sagaValue: object
  // compValue: object
}

export let versionTable: Array<versionRow>
export const cmodeValue = getParam(cmode_name) ?? null

const boot = async (rootId: string = 'root') => {
  try {
    initDev()

    // billPayment : beta, stable component 구분
    // Code Split 이 무시됨, compValue 로 인해 사용하지 않는 모듈의 chunk file 까지 로드
    versionTable = [
      {
        id: 'v1',
        sagaValue: rootSaga,
        // compValue: import(/* webpackChunkName: "bill-payment" */ './components/bill-payment'),
      },
      {
        id: 'v2',
        sagaValue: rootSagaBeta,
        // compValue: import(
        //   /* webpackChunkName: "bill-payment-v2" */ './components/version/V2/bill-payment'
        // ),
      },
      {
        id: 'v3',
        sagaValue: rootSagaBeta,
      },
    ]

    const sepVersionParam = getParam(version_name) ?? null

    // console.log('location :', sepParam, typeof (sepParam), window.location.href)
    const { result } = await Bridge.getNativeInfo()
    const nativeInfo = result || EmptyNativeInfo
    const nativeLang = oc(nativeInfo).language(LANGUAGE.EN)
    const currentLanguage = isDevelopmentMode
      ? LANGUAGE.IN
      : (LANGUAGE_FOR_I18N as any)[nativeLang] || LANGUAGE.EN

    await i18n.init(currentLanguage)
    numeral.init(currentLanguage)

    api.init(store, nativeInfo)

    initNativeInfo(store, nativeInfo)

    const rootSagaModule: any = versionTable.find(v => v.id === (sepVersionParam ?? 'v1'))

    // if (sepParam === "true") {
    //   // beta
    //   sagaMiddleware.run(rootSagaBeta)
    // } else {
    //   // stable
    //   sagaMiddleware.run(rootSaga)
    // }
    sagaMiddleware.run(rootSagaModule.sagaValue)

    render(
      <Provider store={store}>
        <Router history={history}>
          <App />
        </Router>
      </Provider>,
      document.getElementById(rootId),
    )
  } catch (e) {
    console.error(e)
  }
}

bridgeCore.init(async () => await boot())
